export const getInitials = (name) => {
  console.log(name, "name");
  const split = name?.split(" ");
  let initials = "";
  split?.forEach((item) => {
    initials += `${item[0]} `;
  });
  return initials;
};
export const getInitial = (name) => {
  if (name) {
    const parts = name?.split(" ");
    const firstName = parts[0];
    const initial = firstName ? firstName.charAt(0).toUpperCase() : "";
    return initial;
  } else {
    return "";
  }
};
